/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayModelRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.gatewayModels', {
            url: '/gatewayModels',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway-model.gateway-models'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway-model.gateway-models"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, gatewayModelTableConfig) {
                        return gatewayModelTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/gateway-model/gateway-model.routes.js